import script from "./enterprise-detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./enterprise-detail.vue?vue&type=script&lang=ts&setup=true"

import "./enterprise-detail.vue?vue&type=style&index=0&id=b8786496&lang=stylus&scoped=true"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8786496"]])

export default __exports__